import React, { Component } from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';
import Layout from './components/common/Layout';
import Home from './components/views/Home';
import Discover from './components/views/Discover';
import CaseStudies from './components/views/CaseStudies';
import About from './components/views/About';
import News from './components/views/News';
import Contact from './components/views/Contact';
import AilsaBayStorybook from './components/common/AilsaBayStorybook';
import Careers from './components/common/Careers';
import Graduates from './components/common/Graduates';
import IrelandCraftBeersCaseStudy from './components/common/IrelandCraftBeersCaseStudy';
import BlogPost from './components/common/BlogPost';
import Privacy from './components/common/Privacy';
import JobAdvertSeniorEngineer from './components/common/JobAdvertSeniorEngineer';
import Error404 from './components/common/Error404';
import JobAdvertDBA from './components/common/JobAdvertDBA';
import './App.css';
import ScrollToTop from './ScrollToTop';
import FadeIn from './components/common/FadeIn';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  render() {
    if (this.state.isLoading) {
      // we will put app-wide page loading animations here
      return (
        <div className="loading-screen">
          <div className="loading-text">Loading...</div>
        </div>
      );
    }
    return (
      <BrowserRouter>
        <ScrollToTop>
          <Layout>
            <Switch>
              <Redirect exact path="/" to="/home" />
              <Switch>
                <Route path="/home" component={Home} />
                <Route path="/discover" component={Discover} />
                <Route path="/about" component={About} />
                <Route
                  path="/case_studies/ailsabay"
                  component={AilsaBayStorybook}
                />
                <Route path="/news/:postID" component={FadeIn(BlogPost)} />
                <Route path="/news" component={News} />
                <Route path="/contact" component={Contact} />
                <Route
                  path="/case_studies/irelandcraftbeers"
                  component={IrelandCraftBeersCaseStudy}
                />
                <Route path="/case_studies" component={CaseStudies} />
                <Route
                  path="/careers/seniorengineer"
                  component={JobAdvertSeniorEngineer}
                />
                <Route
                  path="/careers/businessanalyst"
                  component={JobAdvertDBA}
                />
                <Route path="/careers" component={Careers} />
                <Route path="/graduates" component={Graduates} />
                <Route path="/privacy" component={Privacy} />
                <Route path="/error" component={Error404} />
                <Route>
                  <Redirect to="/error" />
                </Route>
              </Switch>
            </Switch>
          </Layout>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js